import React from 'react';
import {Navigate } from 'react-router-dom';



const PrivateRoute: React.FC<any> = ({element, isAuthenticated, to="/" }) => {
  return isAuthenticated ? element : <Navigate to={to} />;
};

export default PrivateRoute;
